export default __webpack_public_path__ + "static/media/box3.188b4724.svg";